import { OrderFields } from "../../../constants";
import type { TOrderFormData } from "../../../models/orderForm";
import type { TPrefillInfoParams } from "./types";

const getPrefillCommonData = ({ storedData, affiliate }: TPrefillInfoParams): Partial<TOrderFormData> => {
  const isDomestic = storedData?.[OrderFields.IS_DOMESTIC];
  const isIntraEurope = storedData?.[OrderFields.IS_INTRA_EUROPE];
  const isFromOrigin = storedData?.[OrderFields.IS_FROM_ORIGIN];
  const promoCode = storedData?.[OrderFields.PROMO_CODE];
  const offerGroupId = storedData?.[OrderFields.OFFER_GROUP_ID];
  const shipmentId = storedData?.[OrderFields.SHIPMENT_ID];
  const isShipmentSignedIn = storedData?.[OrderFields.SHIPMENT_SIGNED_IN];
  const affiliateId = storedData?.[OrderFields.AFFILIATE_ID] ?? affiliate?.id;
  const affiliateReturnUrl = storedData?.[OrderFields.AFFILIATE_RETURN_URL] ?? affiliate?.returnUrl;
  const price = storedData?.[OrderFields.PRICE];
  const originalPrice = storedData?.[OrderFields.ORIGINAL_PRICE];

  const valuesToPrefill: Partial<TOrderFormData> = {
    [OrderFields.IS_DOMESTIC]: isDomestic,
    [OrderFields.IS_INTRA_EUROPE]: isIntraEurope,
    [OrderFields.IS_FROM_ORIGIN]: isFromOrigin,
    [OrderFields.PROMO_CODE]: promoCode,
    [OrderFields.OFFER_GROUP_ID]: offerGroupId,
    [OrderFields.SHIPMENT_ID]: shipmentId,
    [OrderFields.SHIPMENT_SIGNED_IN]: isShipmentSignedIn,
    [OrderFields.AFFILIATE_ID]: affiliateId,
    [OrderFields.AFFILIATE_RETURN_URL]: affiliateReturnUrl,
    [OrderFields.PRICE]: price,
    [OrderFields.ORIGINAL_PRICE]: originalPrice,
  };
  return valuesToPrefill;
};
export default getPrefillCommonData;
